import { getYaNative } from '@yanolja-org/ya-native';

interface IKakaoShareProps {
  kakaoSettings: Kakao.Link.DefaultFeedSettings;
  url?: string;
  deeplink?: string;
}

/**
 *
 * @param kakaoSettings
 * @param url 웹/모바일웹에서 공유시, 카카오톡 공유하기 템플릿에 연결할 url
 * @param deeplink 야놀자 앱에서 공유시, 카카오톡 공유하기 템플릿에 연결할 딥링크
 */
export const shareKaKaoMessage = ({ kakaoSettings, url, deeplink }: IKakaoShareProps): void => {
  const yaNative = getYaNative();

  if (yaNative.isEnabled && deeplink) {
    yaNative.shareContent({
      sendTo: 'kakao',
      data: {
        title: kakaoSettings.content?.title || '',
        description: kakaoSettings.content?.description,
        imgUrl: kakaoSettings.content?.imageUrl,
        webUrl: url,
        mobileWebUrl: url,
        deepLink: deeplink,
      },
    });
  } else {
    Kakao?.Link.sendDefault(kakaoSettings);
  }
};
